import "./OKRs.css";
import React from "react";

const StatusBar = (props) => {


  let statusSummary = props && props.statusSummary !== undefined ? props.statusSummary : null;


  return (
    <React.Fragment>
      <div className="argus-status-bar">
        <div className="badge-status">
          <small className="badge-label">Completed</small>
          <p className="status-count">{statusSummary !== null && statusSummary.completed !== null ? statusSummary.completed : 0}</p>
        </div>
        <div className="badge-status">
          <small className="badge-label">In Progress</small>
          <p className="status-count">{statusSummary !== null && statusSummary.inProgress !== null ? statusSummary.inProgress : 0}</p>
        </div>
        <div className="badge-status">
          <small className="badge-label">Opened</small>
          <p className="status-count">{statusSummary !== null && statusSummary.opened !== null ? statusSummary.opened : 0}</p>
        </div>
        <div className="badge-status">
          <small className="badge-label">Review</small>
          <p className="status-count">{statusSummary !== null && statusSummary.review !== null ? statusSummary.review : 0}</p>
        </div>
        <div className="badge-status">
          <small className="badge-label">To Do</small>
          <p className="status-count">{statusSummary !== null && statusSummary.toDo !== null ? statusSummary.toDo : 0}</p>
        </div>
        <div className="badge-status">
          <small className="badge-label">Un Assigned</small>
          <p className="status-count">{statusSummary !== null && statusSummary.unAssigned !== null ? statusSummary.unAssigned : 0}</p>
        </div>
        {/* <Grid container spacing={1}> */}
        {/* <Grid item xl={3} lg={3} md={6} xs={12}>
            <div className="card-status-box">
              <div className="status-icon">
                <div className="icon-box">
                  <AddTaskIcon />
                </div>
              </div>
              <div className="status-card">
                <h5 className="status-head">Completed</h5>
                <p className="status-count">{statusSummary !== null && statusSummary.completed !== null ? statusSummary.completed : 0}</p>
              </div>
            </div>
          </Grid>
          <Grid item xl={3} lg={3} md={6} xs={12}>
            <div className="card-status-box">
              <div className="status-icon">
                <div className="icon-box">
                  <ScheduleIcon />
                </div>
              </div>
              <div className="status-card">
                <h5 className="status-head">Closed</h5>
                <p className="status-count">{statusSummary !== null && statusSummary.closed !== null ? statusSummary.closed : 0}</p>
              </div>
            </div>
          </Grid>
          <Grid item xl={3} lg={3} md={6} xs={12}>
            <div className="card-status-box">
              <div className="status-icon">
                <div className="icon-box">
                  <HourglassEmptyIcon />
                </div>
              </div>
              <div className="status-card">
                <h5 className="status-head">In Progress</h5>
                <p className="status-count">{statusSummary !== null && statusSummary.inProgress !== null ? statusSummary.inProgress : 0}</p>
              </div>
            </div>
          </Grid>
          <Grid item xl={3} lg={3} md={6} xs={12}>
            <div className="card-status-box">
              <div className="status-icon">
                <div className="icon-box">
                  <PauseIcon />
                </div>
              </div>
              <div className="status-card">
                <h5 className="status-head">Opened</h5>
                <p className="status-count">{statusSummary !== null && statusSummary.opened !== null ? statusSummary.opened : 0}</p>
              </div>
            </div>
          </Grid>
          <Grid item xl={3} lg={3} md={6} xs={12}>
            <div className="card-status-box">
              <div className="status-icon">
                <div className="icon-box">
                  <DoNotDisturbAltIcon />
                </div>
              </div>
              <div className="status-card">
                <h5 className="status-head">Review</h5>
                <p className="status-count">{statusSummary !== null && statusSummary.review !== null ? statusSummary.review : 0}</p>
              </div>
            </div>
          </Grid>
          <Grid item xl={3} lg={3} md={6} xs={12}>
            <div className="card-status-box">
              <div className="status-icon">
                <div className="icon-box">
                  <EventBusyIcon />
                </div>
              </div>
              <div className="status-card">
                <h5 className="status-head">To DO</h5>
                <p className="status-count">{statusSummary !== null && statusSummary.toDo !== null ? statusSummary.toDo : 0}</p>
              </div>
            </div>
          </Grid>
          <Grid item xl={3} lg={3} md={6} xs={12}>
            <div className="card-status-box">
              <div className="status-icon">
                <div className="icon-box">
                  <EventBusyIcon />
                </div>
              </div>
              <div className="status-card">
                <h5 className="status-head">UnAssigned</h5>
                <p className="status-count">{statusSummary !== null && statusSummary.unAssigned !== null ? statusSummary.unAssigned : 0}</p>
              </div>
            </div>
          </Grid> */}
        {/* <Grid item xs={3}>
          <div className="card-status-box">
                <div className="status-card">
                <h5 className="status-head">Linked</h5>
                <p className="status-count">8</p>
                </div>
                <div className="status-icon">
                    <div className="icon-box">
                    <LinkIcon />
                    </div>
                </div>
            </div>
          </Grid> */}
        {/* </Grid> */}
        {/* <table className="status-table">
          <tr>
            <th>Completed</th>
            <th>Overdue</th>
            <th>In Progress</th>
            <th>Not Started</th>
            <th>On Hold</th>
            <th>Due this Month</th>
            <th>Linked</th>
          </tr>
          <tbody>
            <tr>
              <td className="completed">8</td>
              <td className="overdue">5</td>
              <td className="in-progress">11</td>
              <td className="not-started">1</td>
              <td className="on-hold">5</td>
              <td className="due">3</td>
              <td className="linked">8</td>
            </tr>
          </tbody>
        </table> */}
      </div>
    </React.Fragment>
  );
};

export default StatusBar;
